<template>
<div class="chapter">
<div class="inner_page">
<p class="ct" id="d7e159310"><b>ACKNOWLEDGMENTS </b></p>
<p class="tx1" id="d7e160610">This is where I get to thank the many people who so generously shared their time, talents, and expertise with me. I’d like to thank my husband Mark, who helped so much in the research and proofreading, my daughter Deirdre DeLay for her support and research links, and my friends Douglas Clegg and Raul Silva for their interest and support.</p>
<p class="tx" id="d7e163410">Thanks to Gina Panettieiri, who likes to stroll around cemeteries, too. You started the wheels rolling.</p>
<p class="tx" id="d7e164510">Especially helpful and informative were all the people at the Rhode Island Paranormal Research Group (T.R.I.P.R.G.) and its founder and director, Andrew Laird, who gave invaluable help and support when it was most needed. My thanks also to T.R.I.P.R.G. sensitives and investigators Maggie Florio and Kym Black, whose e-mails, interviews, and phone conversations were so amazingly detailed and helpful.</p>
<p class="tx" id="d7e167710">A big thanks also to the Demon Hunter, AKA Nathan Schoonover, and his talented mate, Kristy Petersen Schoonover.</p>
<p class="tx" id="d7e169410">Nelia and John Petit were quite helpful in sharing their knowledge for the section on malevolent hauntings; thanks very much for filling me in on entities that made my blood run cold!</p>
<p class="tx" id="d7e171110">Many thanks also to Kathy Conder at Michigan Paranormal, Will Murray, and Elizabeth Bissette. Liz is the world’s fastest typist and had some great anecdotes to relate and photos to share.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Elli_9781605507057_epub_c9_r1.vue?2bfe5ded